<template>
  <div class="container pt-mb-5 pt-3 mb-sm-5 mb-3">
    <div class="dashboard">
      <div class="row mt-5">
        <div class="col-lg-3 col-md-4 mb-5">
          <div class="sidebar">
            <a href="#"><h3 class="ser-vis-head dasssh">Dashboard</h3></a>
            <ul>
              <li>
                <a :href="myProfileRoute" class="hover-color"> <img :src="props.image1" class="iamgdd1" />User Profile</a>
              </li>
              <li class="prof-2">
                <a :href="props.addPet" class="my_pets hover-color"> <img :src="props.image2" class="iamgdd1" /> Pets</a>
              </li>
              <li>
                <a :href="props.myBookings" class="hover-color"> <img :src="props.image3" class="iamgdd1" />My Bookings</a>
              </li>
              <li >
                <a :href="props.myReward" class="hover-color"> <img :src="props.image3" class="iamgdd1" />My Rewards</a>
              </li>
              <li>
                <a :href="props.logoutRoute" class="hover-color"> <img :src="props.image4" class="iamgdd1" />Logout</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-lg-9 col-md-8 mb-5">
          <div class="my-pet-head">
            <h5>My Pets</h5>
            <button class="btn btn-primary add-new-btns" data-bs-toggle="modal" data-bs-target="#addNewPet"><i class="far fa-plus me-2"></i>Add New Pet</button>
          </div>
          <div class="main-content">
            <div class="modal fade" id="addNewPet" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
              <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content model-shadow">
                  <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Add Your Pet</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                  </div>
                  <form @submit.prevent="submitForm" class="contact-page-form" enctype="multipart/form-data">
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-md-12">
                          <div>
                            <InputField class="col-md-12" type="text" :is-required="true" :label="'Pet Name'" placeholder="Enter Your Pet Name" v-model="name" :error-message="errors['name']" :error-messages="errorMessages['name']"></InputField>
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div>
                            <InputField class="col-md-12" type="text" :is-required="true" :label="'Date Of Birth or Age'" placeholder="Enter Your DOB or Age" v-model="dob" :error-message="errors['dob']" :error-messages="errorMessages['dob']"></InputField>
                          </div>
                        </div>
                        <div class="col-md-6 mb-3">
                          <div class="">
                            <label>Gender</label>
                            <select class="form-control" v-model="gender" :class="{ 'is-invalid': errors['gender'] }">
                              <option disabled value="">Select Pet Gender</option>
                              <option v-for="(label, value) in petGenders" :key="value" :value="value">
                                {{ label }}
                              </option>
                            </select>

                            <span class="text-danger">{{ errors['gender'] }}{{ errorMessages['gender'] }}</span>
                          </div>
                        </div>
                        <div class="col-md-6 mb-3">
                          <div class="">
                            <label>Choose Pet</label>
                            <select class="form-control" v-model="pet_type" :class="{ 'is-invalid': errors['pet_type'] }" @change="getBreed(pet_type)">
                              <option value="" disabled="disabled" selected="selected">Select Your Pet</option>
                              <option v-for="(type, index) in petTypes" :key="index" :value="type.id">{{ type.name }}</option>
                            </select>
                            <span class="text-danger">{{ errors['pet_type'] }}{{ errorMessages['pet_type'] }}</span>
                          </div>
                        </div>
                        <div class="col-md-6 mb-3">
                          <div>
                            <label>Breed</label>
                            <select class="form-control" v-model="breed" :class="{ 'is-invalid': errors['breed'] }">
                              <option value="" disabled="disabled" selected="selected">Select Breed</option>
                              <!-- <option value=""></option> -->
                              <option v-for="(breedd, index) in breeds" :key="index" :value="breedd.id">{{ breedd.name }}</option>
                            </select>
                            <span class="text-danger">{{ errors['breed'] }}{{ errorMessages['breed'] }}</span>
                          </div>
                        </div>

                        <div class="col-md-6 mb-3">
                          <div>
                            <label for="food_preference">Food Preference</label>
                            <select class="form-control" id="food_preference" v-model="food_preference" :class="{ 'is-invalid': errors['food_preference'] }">
                              <option value="" disabled="disabled">Select Food Preference</option>
                              <option value="veg">Veg</option>
                              <option value="non_veg">Non-Veg</option>
                            </select>
                            <span class="text-danger">{{ errors['food_preference'] }}{{ errorMessages['food_preference'] }}</span>
                          </div>
                        </div>

                        <div class="col-md-6 mb-3">
                          <div>
                            <label for="vaccination_status">Vaccination Status</label>
                            <select class="form-control" id="vaccination_status" v-model="vaccination_status" :class="{ 'is-invalid': errors['vaccination_status'] }">
                              <option value="" disabled="disabled">Select Vaccination Status</option>
                              <option value="vaccinated">Vaccinated</option>
                              <option value="non_vaccinated">Non-Vaccinated</option>
                            </select>
                            <span class="text-danger">{{ errors['vaccination_status'] }}{{ errorMessages['vaccination_status'] }}</span>
                          </div>
                        </div>

                        <div class="col-md-6 mb-3">
                          <div>
                            <InputField class="col-md-12" type="date" :label="'Last Deworming Date'" placeholder="Last Deworming Date" v-model="last_deworming_date" :error-message="errors['last_deworming_date']" :error-messages="errorMessages['last_deworming_date']"></InputField>
                          </div>
                        </div>
                        <!-- Vaccine Card -->
                        <div class="col-md-6 mb-3">
                          <div>
                            <img :src="imageToShow('vaccine_card')" class="mb-2 w-100" />
                            <InputField
                              class="col-md-12"
                              type="file"
                              :label="'Upload Vaccine Card'"
                              @change="e => handleFileUpload(e, 'vaccine_card')"
                            />
                          </div>
                        </div>

                        <!-- Pet Picture -->
                        <div class="col-md-6 mb-3">
                          <div>
                            <img :src="imageToShow('pet_picture')" class="mb-2 w-100" />
                            <InputField
                              class="col-md-12"
                              type="file"
                              :label="'Upload Pet Picture'"
                              @change="e => handleFileUpload(e, 'pet_picture')"
                            />
                          </div>
                        </div>

                        <!-- Emergency Contact -->
                        <div class="col-md-6 mb-3">
                          <div>
                            <InputField class="col-md-12" type="tel" :is-required="true" :label="'Emergency Contact'" placeholder="Emergency Contact" v-model="emergency_contact" :error-message="errors['emergency_contact']" :error-messages="errorMessages['emergency_contact']"></InputField>
                          </div>
                        </div>

                        <!-- Vet Name -->
                        <div class="col-md-6 mb-3">
                          <div>
                            <InputField class="col-md-12" type="text" :label="'Vet Name'" placeholder="Vet Name" v-model="vet_name" :error-message="errors['vet_name']" :error-messages="errorMessages['vet_name']"></InputField>
                          </div>
                        </div>

                        <!-- Vet Contact -->
                        <div class="col-md-6 mb-3">
                          <div>
                            <InputField class="col-md-12" type="text" :label="'Vet Contact'" placeholder="Vet Contact" v-model="vet_contact" :error-message="errors['vet_contact']" :error-messages="errorMessages['vet_contact']"></InputField>
                          </div>
                        </div>

                        <!-- Food Allergy -->
                        <div class="col-md-6 mb-3">
                          <label>Food Allergy</label>
                          <select class="form-control" id="food_allergy" v-model="food_allergy" :class="{ 'is-invalid': errors['food_allergy'] }">
                            <option value="" disabled>Select</option>
                            <option value="yes">Yes</option>
                            <option value="no">No</option>
                          </select>
                          <span class="text-danger">{{ errors['food_allergy'] }}{{ errorMessages['food_allergy'] }}</span>
                        </div>

                        <!-- Food Allergy Details -->
                        <div class="col-md-6 mb-3" v-if="food_allergy === 'yes'">
                          <div>
                            <InputField class="col-md-12" type="text" :label="'Details of Food Allergy'" placeholder="Details of Food Allergy" v-model="food_allergy_details" :error-message="errors['food_allergy_details']" :error-messages="errorMessages['food_allergy_details']"></InputField>
                          </div>
                        </div>

                        <!-- Feeding Time Preference -->
                        <div class="col-md-6 mb-3">
                          <div>
                            <InputField class="col-md-12" type="text" :label="'Feeding Time Preference'" placeholder="Feeding Time Preference" v-model="feeding_time_preference" :error-message="errors['feeding_time_preference']" :error-messages="errorMessages['feeding_time_preference']"></InputField>
                          </div>
                        </div>

                        <!-- Other Notes -->
                        <div class="col-md-12 mb-3">
                          <label>Other Notes</label>
                          <textarea class="form-control" v-model="other_notes"></textarea>
                        </div>
                      </div>
                      <div class="modal-footer">
                        <!-- <button type="button" class="btn btn-danger clos-btn" data-bs-dismiss="modal" id="createP">Close</button> -->
                        <button type="submit" class="btn btn-primary" id="createBuuton">Add<img :src="props.image6" class="iamgd2" /></button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <table class="table table_resposive">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Name</th>
                  <th scope="col">DOB</th>
                  <th scope="col">Gender</th>
                  <th scope="col">Breed</th>
                  <th scope="col">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(petDetails, index) in petDataFromBlade" :key="petDetails.id">
                  <th scope="row" class="middle">{{ index + 1 }}</th>
                  <td>{{ petDetails.name }}</td>
                  <td>{{ petDetails.age }}</td>
                  <td>{{ petDetails.gender }}</td>
                  <td>{{ petDetails.breed.name }}</td>
                  <td class="edit-icon">
                    <div>
                      <i type="button" class="fa-solid fa-pen" data-bs-toggle="modal" :data-bs-target="'#exampleModal' + index" @click="editPet(petDetails)"></i>
                    </div>
                    <div>
                      <i class="fa-solid fa-trash ms-3" data-bs-toggle="modal" :data-bs-target="'#trashModal' + index"></i>
                    </div>
                  </td>

                  <div class="modal fade" :id="'exampleModal' + index" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered">
                      <div class="modal-content model-shadow">
                        <div class="modal-header">
                          <h5 class="modal-title" id="exampleModalLabel">Edit</h5>
                          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                          <div class="row">
                            <div class="col-md-12">
                              <div class="mb-3">
                                <label class="mb-2">Name</label>
                                <input id="name" type="text" v-model="petDetails.name" class="form-control" />
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="">
                                <label class="mb-2">Date Of Birth / Age</label>
                                <input id="dob" class="form-control" type="text" v-model="petDetails.age" />
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="mb-3">
                                <label class="mb-2">Gender</label>
                                <select class="form-control" v-model="petDetails.gender">
                                  <option v-for="(label, value) in petGenders" :key="value" :value="value">
                                    {{ label }}
                                  </option>
                                </select>
                              </div>
                            </div>
                            <div class="col-md-12">
                              <div>
                                <label class="mb-2">Breed</label>
                                <input class="form-control" v-model="petDetails.breed.name" readonly disable />
                              </div>
                            </div>
                            <!-- Food Preference -->
                            <div class="col-md-6 mb-3">
                              <div>
                                <label class="mb-2">Food Preference</label>
                                <select class="form-control" v-model="petDetails.food_preference">
                                  <option value="veg">Veg</option>
                                  <option value="non_veg">Non-Veg</option>
                                </select>
                              </div>
                            </div>

                            <!-- Vaccination Status -->
                            <div class="col-md-6 mb-3">
                              <div>
                                <label class="mb-2">Vaccination Status</label>
                                <select class="form-control" v-model="petDetails.vaccination_status">
                                  <option value="vaccinated">Vaccinated</option>
                                  <option value="non_vaccinated">Non-Vaccinated</option>
                                </select>
                              </div>
                            </div>

                            <!-- Last Deworming Date -->
                            <div class="col-md-6 mb-3">
                              <div>
                                <label class="mb-2">Last Deworming Date</label>
                                <input class="form-control" type="date" v-model="petDetails.last_deworming_date" />
                              </div>
                            </div>

                            <!-- Emergency Contact -->
                            <div class="col-md-6 mb-3">
                              <div>
                                <label class="mb-2">Emergency Contact</label>
                                <input class="form-control" type="tel" v-model="petDetails.emergency_contact" />
                              </div>
                            </div>

                            <!-- Vet Name -->
                            <div class="col-md-6 mb-3">
                              <div>
                                <label class="mb-2">Vet Name</label>
                                <input class="form-control" type="text" v-model="petDetails.vet_name" />
                              </div>
                            </div>

                            <!-- Vet Contact -->
                            <div class="col-md-6 mb-3">
                              <div>
                                <label class="mb-2">Vet Contact</label>
                                <input class="form-control" type="text" v-model="petDetails.vet_contact" />
                              </div>
                            </div>

                            <!-- Food Allergy -->
                            <div class="col-md-6 mb-3">
                              <div>
                                <label class="mb-2">Food Allergy</label>
                                <select class="form-control" v-model="petDetails.food_allergy">
                                  <option value="no">No</option>
                                  <option value="yes">Yes</option>
                                </select>
                              </div>
                            </div>

                            <!-- Food Allergy Details (conditional) -->
                            <div class="col-md-6 mb-3" v-if="petDetails.food_allergy === 'yes'">
                              <div>
                                <label class="mb-2">Details of Food Allergy</label>
                                <input class="form-control" type="text" v-model="petDetails.food_allergy_details" />
                              </div>
                            </div>

                            <!-- Feeding Time Preference -->
                            <div class="col-md-6 mb-3">
                              <div>
                                <label class="mb-2">Feeding Time Preference</label>
                                <input class="form-control" type="text" v-model="petDetails.feeding_time_preference" />
                              </div>
                            </div>

                            <!-- Other Notes -->
                            <div class="col-md-12 mb-3">
                              <div>
                                <label class="mb-2">Other Notes</label>
                                <textarea class="form-control" v-model="petDetails.other_notes"></textarea>
                              </div>
                            </div>

                            <!-- New File Uploads -->
                            <!-- <div class="col-md-6 mb-3">
                              <div>
                                <label class="mb-2">Update Vaccine Card</label>
                                <input class="form-control" type="file" />
                              </div>
                            </div>

                            <div class="col-md-6 mb-3">
                              <div>
                                <label class="mb-2">Update Pet Picture</label>
                                <input class="form-control" type="file" />
                              </div>
                            </div> -->

                            <!-- Vaccine Card -->
                            <div class="col-md-6 mb-3">
                              <div>
                                <img :src="imageToShow('vaccine_card')" class="mb-2 w-100" />
                                <InputField
                                  class="col-md-12"
                                  type="file"
                                  :label="'Upload Vaccine Card'"
                                  @change="e => handleFileUpload(e, 'vaccine_card')"
                                />
                              </div>
                            </div>

                            <!-- Pet Picture -->
                            <div class="col-md-6 mb-3">
                              <div>
                                <img :src="imageToShow('pet_picture')" class="mb-2 w-100" />
                                <InputField
                                  class="col-md-12"
                                  type="file"
                                  :label="'Upload Pet Picture'"
                                  @change="e => handleFileUpload(e, 'pet_picture')"
                                />
                              </div>
                            </div>

                          </div>
                        </div>
                        <div class="modal-footer">
                          <!-- <button type="button" class="btn btn-danger clos-btn" data-bs-dismiss="modal">Close</button> -->
                          <button type="button" class="btn btn-primary" @click="updatePet(petDetails)" data-bs-dismiss="modal">Update<img :src="props.image6" class="iamgd2" /></button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="modal fade" :id="'trashModal' + index" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered">
                      <div class="modal-content model-shadow">
                        <div class="modal-header">
                          <h5 class="modal-title" id="exampleModalLabel">Are You Sure?</h5>
                          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>

                        <div class="modal-footer">
                          <button type="button" class="btn btn-danger clos-btn" data-bs-dismiss="modal">Close</button>
                          <button type="button" class="btn btn-primary" @click="deletedata(petDetails.id)" data-bs-dismiss="modal">Delete<img :src="props.image6" class="iamgd2" /></button>
                        </div>
                      </div>
                    </div>
                  </div>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- <div class="spring-img">
    <img :src="props.image1" />
  </div>

  <div class="spring-img-2">
    <img :src="props.image2" />
  </div> -->
</template>
<script setup>
import { ref } from 'vue'
import axios from 'axios'
import * as yup from 'yup'
import { useField, useForm } from 'vee-validate'
import InputField from '@/vue/components/form-elements/InputField.vue'

const errorMessages = ref({})
const props = defineProps({
  petData: Array,
  updatePet: String,
  deleteRoute: String,
  createPet: String,
  petTypes: Array,
  petGenders: Array,
  myBookings: String,
  breeds: String,
  myProfileRoute: String,
  image1: String,
  image2: String,
  image3: String,
  image4: String,
  image5: String,
  image6: String,
  myReward: String,
})
const petDataFromBlade = ref(props.petData)
const isModalOpen = ref(false)
const editedPet = ref(null)
const breeds = ref(null)

const getBreed = async (id) => {
  const response = await axios.get(`${props.breeds}?pettype_id=${id}`)
  breeds.value = response.data.data
}
const editPet = (petDetails) => {
  editedPet.value = { ...petDetails }
  isModalOpen.value = true
}


const previews = ref({
  vaccine_card: null,
  pet_picture: null
})

const handleFileUpload = (event, key) => {
  const file = event.target.files[0]
  if (!file) return

  const reader = new FileReader()
  reader.onload = () => {
    previews.value[key] = reader.result
  }
  if (key === 'vaccine_card') {
    vaccine_card.value = file
  } else if (key === 'pet_picture') {
    pet_picture.value = file
  }
  reader.readAsDataURL(file)
  return file
}

const imageToShow = (key) => {
  if (previews.value[key]) return previews.value[key]

  // fallback from editedPet (used on edit modal)
  if (editedPet.value && editedPet.value[key]) {
    return editedPet.value[key].startsWith('http')
      ? editedPet.value[key]
      : `${window.location.origin}/storage/${editedPet.value[key]}`
  }
  return ''
}

const deletedata = async (id) => {
  try {
    console.log('deleteId', id)
    const res = await axios.get(`${props.deleteRoute}?id=${id}`)
    if (res) {
      const index = petDataFromBlade.value.findIndex((pet) => pet.id === id)
      if (index !== -1) {
        const updatedPetData = [...petDataFromBlade.value]
        updatedPetData.splice(index, 1)
        petDataFromBlade.value = updatedPetData
      }
    }
  } catch (error) {
    console.log('while deleting data', error)
  }
}
const updatePet = async (data) => {
  const updateDat = await axios.post(props.updatePet, {
    name: data.name,
    gender: data.gender,
    date_of_birth: data.age,
    food_preference: data.food_preference,
    vaccination_status: data.vaccination_status,
    last_deworming_date: data.last_deworming_date,
    vaccine_card: data.vaccine_card,
    pet_picture: data.pet_picture,
    emergency_contact: data.emergency_contact,
    vet_name: data.vet_name,
    vet_contact: data.vet_contact,
    food_allergy: data.food_allergy,
    food_allergy_details: data.food_allergy_details,
    feeding_time_preference: data.feeding_time_preference,
    other_notes: data.other_notes,
    id: data.id
  })
  if (updateDat) {
    window.successSnackbar('Pet Updated Successfully')
    // const updateClose = document.getElementById('updateClose')+data.id;
    // updateClose.click();
  }
}
const validationSchema = yup.object({
  name: yup.string().required('Name is a required field'),
  dob: yup.string().required('DOB / Age is a required field'),
  gender: yup.string().required('Gender is a required field'),
  pet_type: yup.string().required('Pet type is a required field'),
  breed: yup.string().required('Breed is a required field'),
  food_preference: yup.string().required('Food preference is a required field'),
  vaccination_status: yup.string().required('Vaccination status is a required field'),
  emergency_contact: yup.string().required('Emergency contact is a required field'),
  food_allergy: yup.string().required('Food allergy status is a required field')
})

const { handleSubmit, errors, resetForm, image1, image2 } = useForm({
  validationSchema
})
const { value: name } = useField('name')
const { value: dob } = useField('dob')
const { value: gender } = useField('gender')
const { value: pet_type } = useField('pet_type')
const { value: breed } = useField('breed')
const { value: food_preference } = useField('food_preference')
const { value: vaccination_status } = useField('vaccination_status')
const { value: last_deworming_date } = useField('last_deworming_date')
const { value: vaccine_card } = useField('vaccine_card')
const { value: pet_picture } = useField('pet_picture')
const { value: emergency_contact } = useField('emergency_contact')
const { value: vet_name } = useField('vet_name')
const { value: vet_contact } = useField('vet_contact')
const { value: food_allergy } = useField('food_allergy')
const { value: food_allergy_details } = useField('food_allergy_details')
const { value: feeding_time_preference } = useField('feeding_time_preference')
const { value: other_notes } = useField('other_notes')

const submitForm = handleSubmit(async () => {
  const submitButton = document.getElementById('createBuuton')
  submitButton.disabled = true
  try {
    const formData = new FormData();
    formData.append('name', name.value);
    formData.append('dob', dob.value);
    formData.append('gender', gender.value);
    formData.append('pet_type', pet_type.value);
    formData.append('breed', breed.value);
    formData.append('food_preference', food_preference.value);
    formData.append('vaccination_status', vaccination_status.value);
    formData.append('last_deworming_date', last_deworming_date.value);
    formData.append('vaccine_card', vaccine_card.value);
    formData.append('pet_picture', pet_picture.value);
    formData.append('emergency_contact', emergency_contact.value);
    formData.append('vet_name', vet_name.value);
    formData.append('vet_contact', vet_contact.value);
    formData.append('food_allergy', food_allergy.value);
    formData.append('food_allergy_details', food_allergy_details.value);
    formData.append('feeding_time_preference', feeding_time_preference.value);
    formData.append('other_notes', other_notes.value);

    // Send the form data with the axios POST request
    const createPet = await axios.post(props.createPet, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    console.log('createPet', createPet)
    if (createPet) {
      submitButton.disabled = false
      petDataFromBlade.value.unshift(createPet.data)
      window.successSnackbar('Pet Added Successfully')
      setTimeout(() => {
        location.reload()
      }, 1000)

      const createPButton = document.getElementById('createP')
      createPButton.click()
      name.value = ''
      dob.value = ''
      gender.value = ''
      pet_type.value = ''
      breed.value = ''
      food_preference.value = ''
      vaccination_status.value = ''
      last_deworming_date.value = ''
      vaccine_card.value = null
      pet_picture.value = null
      emergency_contact.value = ''
      vet_name.value = ''
      vet_contact.value = ''
      food_allergy.value = ''
      feeding_time_preference.value = ''
      other_notes.value = ''

      resetForm()
    }
  } catch (error) {
    console.log('error while submittng form', error)
  }
})
const closeModal = () => {
  isModalOpen.value = false
}
const saveChanges = () => {
  closeModal()
}
</script>

<style scoped>
/* .dashboard {
  display: flex;
  margin: 0 auto;
} */

.sidebar {
  max-width: 100%;
  padding: 20px;
  top: 48px;
  border-radius: 10px;
  position: static;
  box-shadow: none !important;
  background: #f8f8f8;
}

.sidebar h2 {
  margin-bottom: 20px;
}

.sidebar ul {
  list-style: none;
  padding: 0;
}

.sidebar ul li {
  margin-bottom: 10px;
  padding: 10px 15px;
}

.sidebar ul li a {
  text-decoration: none;
  color: #2e2928;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
}

/* .sidebar ul li a:hover {
  color: #bf360c;
} */

.main-content {
  flex: 1;
  /* padding: 20px; */
  margin-left: 0px !important;
  border-radius: 10px;
  /* margin-top: 40px; */
  background-color: white;
  border: 1px solid #ececec;
  /* box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px; */
}

.table-head tr td {
  padding: 1rem 1.5rem;
  white-space: nowrap;
}

.table tbody tr td {
  border-bottom: 1px dashed #ececec !important;
}
.middle {
  border-bottom: 1px dashed #ececec !important;
}

.stats {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.stat-card {
  flex: 1;
  padding: 10px;
  background-color: #f0f0f0;
  border-radius: 5px;
  text-align: center;
}

.order-list {
  list-style: none;
  padding: 0;
}

.order-list li {
  margin-bottom: 5px;
  border: 1px solid #ddd;
  padding: 5px;
  display: flex;
  justify-content: space-between;
}
.clos-btn {
  color: #000;
  background-color: #ffff !important;
  border-radius: 10px;
}

.add-new-btns {
  color: black;
  background: transparent;
}
.add-new-btns:hover {
  color: white;
  background-color: #bf360c;
}
.web-bg {
  background-color: #fbfbfb;
}

.middle {
  vertical-align: middle;
}

.edit-icon {
  display: flex;
}

.edit-icon i {
  cursor: pointer;
}

/* .edit-icon i:hover {
  color: #bf360c;
} */

.my-pet-head {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  align-items: center;
  /* border-bottom: 1px dashed #bf360c; */
  /* padding-bottom: 20px; */
}

.my-pet-head h5 {
  font-size: 20px;
  font-weight: 600;
  color: #2e2928;
}
.sidebar ul li a.active {
  color: #bf360c !important;
}
.my_pets {
  color: #bf360c !important;
}

.web-bg {
  position: relative;
}

.spring-img {
  position: absolute;
  bottom: 20px;
  left: -40px;
}

.spring-img img {
  width: 150px;
}

.spring-img-2 img {
  width: 130px;
}

.spring-img-2 {
  position: absolute;
  top: 30px;
  right: 0;
}

.iamgdd1 {
  width: 30px;
  margin-right: 10px;
}

.sidebar ul li:hover {
  background-color: #f9ede8;
  border-radius: 20px;
}

.prof-2 {
  background-color: #f9ede8 !important;
  border-radius: 20px;
  margin-bottom: 10px;
}
.sidebar ul li:hover .hover-color {
  color: #bf360c !important;
}

.table_resposive {
  border-radius: 10px 10px 0px 0px;
}

/* #addNewPet .contact-page-form label {
    margin-bottom: 10px;
    color: #2e2928;
    font-weight: 550;
  } */

/* .contact-page-form label {
  font-weight: 550 !important;
} */

.model-shadow {
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px !important;
  border: none !important;
  border-radius: 15px;
  padding: 20px;
}

.iamgd2 {
  width: 20px;
  margin-left: 10px;
}

label {
  color: #000;
}

@media screen and (max-width: 1600px) {
  .spring-img-2 img {
    display: none;
  }
  .spring-img img {
    display: none;
  }
}

@media screen and (max-width: 1199px) {
  /* .sidebar {
    height: 250px;
  } */
}

@media screen and (max-width: 991px) {
  .table_resposive {
    display: block;
    width: 100%;
    overflow-x: auto;
  }
}

@media screen and (max-width: 767px) {
  .web-bg .sidebar {
    height: auto !important;
  }
  .web-bg .main-content {
    margin-top: 20px;
  }
}
</style>
